module.exports = __webpack_public_path__ + "static/media/bg-xanh-2-copy.ab7a40fd.png";